// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__PnmYn","tab":"Tabs_tab__IuRtE","tabActive":"Tabs_tabActive__E0rZf"};